<template>
    <div>
        <Search />
        <Table />
        <Pagination />
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import Pagination from './pagination';
import Search from './search';
import Table from './table';

const { mapActions } = createNamespacedHelpers('device');

export default {
    components: { Pagination, Search, Table },
    methods: {
        ...mapActions(['resetState', 'getDevices']),
    },
    mounted() {
        this.getDevices();
    },
    beforeDestroy() {
        this.resetState();
    },
};
</script>
